import { render, staticRenderFns } from "./SetAdminPassword.vue?vue&type=template&id=2086cfd7&scoped=true&"
import script from "./SetAdminPassword.vue?vue&type=script&lang=js&"
export * from "./SetAdminPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086cfd7",
  null
  
)

export default component.exports